<template>
  <el-dialog
    title="上传多个文件"
    :visible.sync="batchUploadFileDialogVisible"
    width="50%"
    :before-close="dialogClose"
    style="max-height: 550px; overflow-y: auto"
  >
    <div>
      <el-upload
        action=""
        :file-list="filesList"
        :show-file-list="false"
        multiple
        :before-remove="beforeRemove"
        :http-request="customRequest"
        :on-remove="handleRemove"
      >
        <div style="width: 650px">
          <p>
            <el-badge :value="filesList.length" :hidden="filesList.length == 0">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-badge>
          </p>
          <div v-for="(value, key) in process" :key="value.url">
            <div>
              <div>{{ value.name }}</div>
              <div>
                <el-progress
                  :text-inside="true"
                  :stroke-width="20"
                  :color="customColors"
                  :percentage="percentage(value)"
                ></el-progress>
              </div>
            </div>
          </div>
        </div>
      </el-upload>
    </div>
  </el-dialog>
</template>

<script>
import { sliceUpload } from '../api/comment'
export default {
  name: "batchUploadFile",
  props: {
    batchUploadFileDialogVisible: Boolean,
  },
  data() {
    return {
      customColors: [
        { color: "#409eff", percentage: 99 },
        { color: "#5cb87a", percentage: 100 },
      ],
      filesList: [],
      process: {},
      blobSlice:
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice
    };
  },
  computed: {
    percentage: function () {
      return function (val) {
        return parseInt((Number(val.success) / Number(val.total)) * 100)
      }
    }
  },
  methods: {
    getUuid() {
      if (typeof crypto === 'object') {
        if (typeof crypto.randomUUID === 'function') {
          return crypto.randomUUID()
        }
        if (
          typeof crypto.getRandomValues === 'function' &&
          typeof Uint8Array === 'function'
        ) {
          const callback = (c) => {
            const num = Number(c)
            return (
              num ^
              (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (num / 4)))
            ).toString(16)
          }
          return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
            /[018]/g,
            callback
          )
        }
      }
      let timestamp = new Date().getTime()
      let perforNow =
        (typeof performance !== 'undefined' &&
          performance.now &&
          performance.now() * 1000) ||
        0
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let random = Math.random() * 16
        if (timestamp > 0) {
          random = (timestamp + random) % 16 | 0
          timestamp = Math.floor(timestamp / 16)
        } else {
          random = (perforNow + random) % 16 | 0
          perforNow = Math.floor(perforNow / 16)
        }
        return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16)
      })
    },
    slice(file, piece = 1024 * 1024 * 0.512) {
      let totalSize = file.size
      let start = 0
      let end = start + piece
      let chunks = []
      while (start < totalSize) {
        let blob = this.blobSlice.call(file, start, end)
        chunks.push(blob)
        start = end
        end = start + piece
      }
      return chunks
    },
    uploadSliceFile(name, hash, fileSlice, index, totalSlice) {
      const form = new FormData()
      form.append('md5', hash)
      form.append('file', fileSlice)
      form.append('name', name)
      form.append('index', index)
      form.append('totalSlice', totalSlice)
      sliceUpload(form).then((res) => {
        if (res.data.success) {
          let processData = this.process[hash]
          processData.success += 1
          processData.url = res.data.data
          this.process[hash] = processData
          this.$forceUpdate()
          if (processData.success == processData.total) {
            this.filesList.push({ name: processData.name, url: processData.url })
          }
        } else {
          this.uploadSliceFile(name, hash, fileSlice, index, totalSlice)
        }
      })
    },
    uploadFileFun(file) {
      let storeUUID = this.getUuid()
      let hash = `${file.size}_${file.lastModified}_${storeUUID}_${file.name}`
      let chunks = this.slice(file)
      let name = file.name.substring(0, file.name.lastIndexOf('.'))
      this.process[hash] = {
        total: chunks.length,
        success: 0,
        url: hash,
        name: name
      }
      this.$forceUpdate()
      chunks.forEach((element, index) => {
        this.uploadSliceFile(file.name, hash, chunks[index], index, chunks.length)
      })
    },
    customRequest(params) {
      this.uploadFileFun(params.file)
      return false
    },
    dialogClose() {
      this.$emit("update:batchUploadFileDialogVisible", false);
    },
    handleRemove(file) {
      const uid = file.uid
      this.filesList.splice(
        this.filesList.findIndex((e) => {
          return e.uid == uid
        }),
        1
      )
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    batchSave(callback) {
      this.filesList.forEach((file) => {
        callback(file)
      })
    },
  },
};
</script>

<style scoped></style>
